import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  LOCALE_ID,
  provideEnvironmentInitializer,
} from '@angular/core';
import {
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { registerLocaleData } from '@angular/common';
import { InitService } from '@infodata-group/inf-commons';
import { environment } from '../environments/environment';
import localeFr from '@angular/common/locales/fr';
import {
  commonsProviders,
  commonsProvidersFrom,
} from './config/commons.config';
import { urgencyInterceptor } from './model/interceptor/urgency.interceptor';

registerLocaleData(localeFr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(
      withXhr(),
      withInterceptorsFromDi(),
      withInterceptors([urgencyInterceptor]),
    ),
    provideRouter(appRoutes),
    provideEnvironmentInitializer(() =>
      inject(InitService).init(environment.env),
    ),
    importProvidersFrom(...commonsProvidersFrom),
    commonsProviders,
    { provide: LOCALE_ID, useValue: 'fr' },
  ],
};
